var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 108,
    viewBox: "0 0 153 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.518 1.34424H51.8145V77.3286H149.518V1.34424Z",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8145 12.2036H149.439",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8145 23.0474H149.439",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8145 33.9072H149.439",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8145 44.7661H149.439",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8145 55.626H149.439",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8145 66.4697H149.439",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6738 77.1255V1.34424",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5332 77.1255V1.34424",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3926 77.1255V1.34424",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2363 77.1255V1.34424",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2363 77.1255V1.34424",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106.096 77.1255V1.34424",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.955 77.1255V1.34424",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M127.814 77.1255V1.34424",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M138.658 77.1255V1.34424",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.096 77.1255V1.34424",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7111 41.1301L34.3242 42.7432L35.9373 41.1301L34.3242 39.517L32.7111 41.1301Z",
    fill: "#FF5D0E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0952 29.2339L17.791 31.9297L20.4868 29.2339L17.791 26.538L15.0952 29.2339Z",
    fill: "#FF5D0E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4868 12.6953L30.1328 16.3413L33.7788 12.6953L30.1328 9.04934L26.4868 12.6953Z",
    fill: "#FF5D0E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6902 65.2949C78.3303 63.3729 80.5338 58.0532 78.6117 53.413C76.6897 48.7729 71.37 46.5695 66.7298 48.4915C62.0897 50.4136 59.8863 55.7333 61.8083 60.3734C63.7304 65.0135 69.0501 67.217 73.6902 65.2949Z",
    fill: "#FF5D0E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M79.082 54.8442L84.1758 72.7817L67.5195 78.1255L61.4727 59.4067L79.082 54.8442Z",
    fill: "#FF5D0E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1758 72.7812L87.6133 85.0625H108.785L113.379 84.4219L115.801 76.6875C115.801 76.6875 117.363 74.8906 117.863 76.625C117.879 76.6875 117.973 76.6875 117.988 76.625L118.52 74.4844C118.52 74.4844 119.801 72.9531 120.566 74.8281C120.566 74.8281 122.176 72.2813 122.691 75.0781C122.691 75.0781 124.645 72.875 124.988 75.25L122.691 86.0469L120.973 88.7969C118.895 92.1406 115.379 94.3281 111.457 94.7187L82.1445 97.6875C76.7852 98.2344 71.832 94.7812 70.4883 89.5625L67.5352 78.1094L84.1758 72.7812Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1758 72.7812L87.6133 85.0625H108.785L113.379 84.4219L115.801 76.6875C115.801 76.6875 117.363 74.8906 117.863 76.625C117.879 76.6875 117.973 76.6875 117.988 76.625L118.52 74.4844C118.52 74.4844 119.801 72.9531 120.566 74.8281C120.566 74.8281 122.176 72.2813 122.691 75.0781C122.691 75.0781 124.645 72.875 124.988 75.25L122.691 86.0469L120.973 88.7969C118.895 92.1406 115.379 94.3281 111.457 94.7187L82.1445 97.6875C76.7852 98.2344 71.832 94.7812 70.4883 89.5625L67.5352 78.1094L84.1758 72.7812Z",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5664 47.9224L47.5039 45.4067H58.6914L72.4727 48.0942L71.7227 106.719L23.5977 106.86L28.5664 47.9224Z",
    fill: "#FF5D0E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9949 58.9789C40.149 54.0911 37.1223 49.1932 32.2346 48.0391C27.3469 46.885 22.449 49.9116 21.2948 54.7994C20.1407 59.6871 23.1674 64.585 28.0551 65.7392C32.9429 66.8933 37.8408 63.8666 38.9949 58.9789Z",
    fill: "#FF5D0E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7383 51.5938L12.1914 69.3281L27.4258 78.3125L37.7695 61.8281L22.7383 51.5938Z",
    fill: "#FF5D0E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6912 84.2349L60.7381 84.7505L19.0349 98.8911C8.73806 102.313 -0.340061 91.2349 5.05056 81.813L12.2068 69.313L27.4256 78.2974L26.3318 80.188L55.2693 76.313L68.4881 72.0317C69.6131 71.6724 70.8474 71.7505 71.9099 72.2817L75.1756 73.8911L79.0506 79.4692C79.3318 79.8755 79.3787 80.4067 79.1443 80.8286C78.9256 81.2349 78.5037 81.5474 77.6756 81.2505C77.6756 81.2505 77.0662 83.1255 75.8943 82.688C75.8943 82.688 75.6756 83.6255 73.8474 83.5005C73.8474 83.5005 73.4256 85.438 71.9724 84.5161L69.9256 83.1724L66.6912 84.2349Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6912 84.2349L60.7381 84.7505L19.0349 98.8911C8.73806 102.313 -0.340061 91.2349 5.05056 81.813L12.2068 69.313L27.4256 78.2974L26.3318 80.188L55.2693 76.313L68.4881 72.0317C69.6131 71.6724 70.8474 71.7505 71.9099 72.2817L75.1756 73.8911L79.0506 79.4692C79.3318 79.8755 79.3787 80.4067 79.1443 80.8286C78.9256 81.2349 78.5037 81.5474 77.6756 81.2505C77.6756 81.2505 77.0662 83.1255 75.8943 82.688C75.8943 82.688 75.6756 83.6255 73.8474 83.5005C73.8474 83.5005 73.4256 85.438 71.9724 84.5161L69.9256 83.1724L66.6912 84.2349Z",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6914 81.2661L75.3164 78.063L72.5352 76.2661",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9258 82.7031L74.1602 80.4844L70.7227 78.625",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8652 83.5166L71.834 81.7822L69.7402 80.9229",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8789 80.0005L22.582 80.6724",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6133 53.313H53.2695C49.4883 53.313 46.4414 50.2505 46.4414 46.4849V33.7661H58.6289V53.313H58.6133Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6133 53.313H53.2695C49.4883 53.313 46.4414 50.2505 46.4414 46.4849V33.7661H58.6289V53.313H58.6133Z",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9731 17.0317C62.3637 18.2192 65.4575 22.1254 65.7856 26.6567C66.1606 31.891 65.7231 39.4848 60.5669 42.016C52.4106 46.016 46.4262 35.9848 46.4262 35.9848C46.4262 35.9848 45.0043 22.2035 46.7856 20.0004C48.6137 17.766 52.9575 15.6723 57.9731 17.0317Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8315 41.4698C54.1909 42.9073 57.1909 43.6573 60.5659 42.0011C65.7221 39.4698 66.1596 31.8917 65.7846 26.6417C65.4565 22.1104 62.3627 18.2042 57.9721 17.0167C52.9409 15.6573 48.6127 17.7511 46.8002 19.9698C45.0034 22.1729 46.4409 35.9542 46.4409 35.9542V37.2979",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9103 29.096C48.9728 27.0335 50.5821 24.5492 51.629 21.8304C55.0196 23.2367 58.4884 24.6429 62.1446 24.7835C63.254 24.8304 64.3946 24.7367 65.4415 24.3929C66.4728 24.0492 67.3946 23.471 68.2853 22.8304C69.5978 21.8929 70.879 20.7679 71.3946 19.2523C72.0978 17.1429 71.0509 14.7367 69.3634 13.2835C67.6603 11.8304 65.4415 11.1742 63.2384 10.7679C58.3165 9.83041 52.9728 9.97104 48.5978 12.4085C47.2853 13.1429 46.0353 14.1273 45.4728 15.5179C44.5509 14.7835 43.129 14.8929 42.1759 15.5804C41.2228 16.2679 40.6915 17.4398 40.5353 18.6117C40.379 19.7835 40.5509 20.971 40.754 22.1273C41.1134 24.1273 41.5665 26.1117 42.129 28.0648C42.3946 28.971 42.9571 30.2679 44.0509 30.3773C45.0665 30.4867 46.2384 29.7679 46.9103 29.096Z",
    fill: "#0A0A0A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1884 29.3771C48.8134 27.7365 50.1884 25.8459 51.204 23.7677C51.5009 23.174 51.7665 22.5646 52.0009 21.9396C51.8446 22.0334 51.6728 22.1271 51.5165 22.2052C53.4071 22.9865 55.2978 23.7677 57.2665 24.3302C59.204 24.8927 61.2509 25.2677 63.2665 25.1584C64.2821 25.1115 65.2821 24.9084 66.2196 24.5021C67.0946 24.1271 67.9071 23.5802 68.6884 23.0177C70.0946 22.0021 71.4853 20.7209 71.8915 18.9552C72.2665 17.3146 71.7509 15.5959 70.7821 14.2521C69.704 12.7677 68.1259 11.8146 66.4384 11.1896C64.704 10.549 62.829 10.2209 61.0009 10.0021C59.1571 9.78336 57.2978 9.73649 55.454 9.92399C53.5946 10.1115 51.7665 10.5334 50.0478 11.2521C48.4228 11.924 46.7978 12.8459 45.7196 14.2677C45.4696 14.6115 45.2665 14.9865 45.0946 15.3771C45.3134 15.3146 45.5321 15.2677 45.7509 15.2052C44.5009 14.2209 42.704 14.4709 41.579 15.5334C40.3446 16.6896 40.0009 18.4552 40.0946 20.0802C40.1571 21.049 40.329 22.0021 40.5165 22.9552C40.6884 23.8927 40.8915 24.8146 41.1259 25.7521C41.329 26.6115 41.5478 27.4709 41.8134 28.3146C42.0165 28.9396 42.2821 29.549 42.7196 30.049C44.0009 31.4865 46.0634 30.4709 47.1884 29.3771C47.5478 29.0177 47.0009 28.4709 46.6415 28.8302C46.1728 29.299 45.5946 29.6896 44.9696 29.8927C44.4228 30.0646 43.8759 30.0802 43.454 29.6896C43.0634 29.3302 42.8134 28.8146 42.6415 28.3302C42.3915 27.6115 42.2196 26.8771 42.0321 26.1427C41.6103 24.4709 41.2196 22.7834 41.0009 21.0802C40.7978 19.6115 40.8134 18.0334 41.6571 16.7521C42.0478 16.1584 42.6259 15.6896 43.329 15.5177C43.954 15.3459 44.704 15.4084 45.2353 15.8302C45.4853 16.0177 45.7665 15.9396 45.8915 15.6584C46.5165 14.174 47.9853 13.2052 49.3603 12.5021C50.9384 11.7052 52.6415 11.2052 54.3759 10.924C56.1259 10.6427 57.9071 10.6115 59.6571 10.7209C61.4228 10.8459 63.1884 11.1115 64.8915 11.5646C66.5165 12.0021 68.1415 12.6584 69.3759 13.8302C70.4696 14.8615 71.2509 16.3302 71.2665 17.8615C71.2665 19.5177 70.2509 20.8146 69.0478 21.8302C67.6884 22.9709 66.1103 24.0021 64.329 24.3146C63.3915 24.4865 62.4071 24.4709 61.454 24.3771C60.5009 24.299 59.5634 24.1271 58.6259 23.9084C56.7353 23.4552 54.9071 22.7677 53.1103 22.0334C52.6571 21.8459 52.204 21.6584 51.7665 21.4865C51.5634 21.3927 51.3603 21.5802 51.2821 21.7521C50.4853 23.8146 49.3446 25.7365 47.9384 27.4396C47.5321 27.924 47.1103 28.3927 46.6571 28.8459C46.2665 29.174 46.829 29.7365 47.1884 29.3771Z",
    fill: "#0A0A0A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0358 29.2984C48.0358 29.2984 44.6296 25.1266 42.5983 26.7828C40.5514 28.4391 41.2858 34.0016 43.3171 34.7359C45.3639 35.4547 48.0358 33.7516 48.0358 33.7516V29.2984Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0358 29.2984C48.0358 29.2984 44.6296 25.1266 42.5983 26.7828C40.5514 28.4391 41.2858 34.0016 43.3171 34.7359C45.3639 35.4547 48.0358 33.7516 48.0358 33.7516",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M123.332 84.2827L133.66 54.3765C134.254 52.6577 132.973 50.8765 131.16 50.8765H86.0352C85.5352 50.8765 85.0977 51.2046 84.9414 51.6733L74.0664 85.8765H59.6445C59.1133 85.8765 58.6914 86.2983 58.6914 86.8296C58.6914 87.3608 59.0352 87.564 59.1133 87.7827H115.051C120.645 87.7671 122.613 86.3765 123.332 84.2827Z",
    fill: "#0A0A0A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M74.207 85.4233L84.9258 51.6577C85.0664 51.189 85.5039 50.8765 85.9883 50.8765C86.7383 50.8765 87.2852 51.6108 87.0508 52.3296L75.9102 86.6265C75.6914 87.314 75.0508 87.7671 74.332 87.7671H59.6445C59.1133 87.7671 58.6914 87.3452 58.6914 86.814C58.6914 86.2827 59.1133 85.8608 59.6445 85.8608H73.5977C73.8789 85.8765 74.1289 85.689 74.207 85.4233Z",
    fill: "#9F99AA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9883 50.8765C85.5039 50.8765 85.0664 51.189 84.9258 51.6577L74.207 85.4233C74.1289 85.689 73.8789 85.8608 73.5977 85.8608H59.6445C59.1133 85.8608 58.6914 86.2827 58.6914 86.814C58.6914 87.3452 59.1133 87.7671 59.6445 87.7671H104.082",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M103.223 70.0952L105.379 74.1265L109.27 70.0952L106.816 65.9546L103.223 70.0952Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M122.676 75.079C122.16 72.2665 120.551 74.829 120.551 74.829C119.785 72.954 118.504 74.4853 118.504 74.4853L117.973 76.6259C117.957 76.6884 117.879 76.6884 117.848 76.6259C117.348 74.8915 115.785 76.6884 115.785 76.6884L113.363 84.4228L106.785 88.7196L111.441 94.7196C115.363 94.329 118.863 92.1259 120.957 88.7978L122.676 86.0478L124.973 75.2509C124.629 72.8603 122.676 75.079 122.676 75.079Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M106.582 88.8597L113.379 84.4222L115.801 76.6878C115.801 76.6878 117.363 74.8909 117.863 76.6253C117.879 76.6878 117.973 76.6878 117.988 76.6253L118.52 74.4847C118.52 74.4847 119.801 72.9534 120.566 74.8284C120.566 74.8284 122.176 72.2816 122.691 75.0784C122.691 75.0784 124.645 72.8753 124.988 75.2503L122.691 86.0472L120.973 88.7972C118.895 92.1409 115.379 94.3284 111.457 94.7191",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M118.035 76.4375L116.52 83.3281",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M120.691 74.9688L118.848 83.3281",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M122.629 75.1724L120.801 83.5474",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2852 29.9229C43.2852 29.9229 44.4102 31.7666 46.2227 31.3916",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0183 29.9076C57.8777 30.5013 57.5027 30.9076 57.1589 30.8294C56.8152 30.7513 56.6589 30.2044 56.7996 29.6263C56.9402 29.0326 57.3152 28.6263 57.6589 28.7044C58.0027 28.7826 58.1589 29.3138 58.0183 29.9076Z",
    fill: "#0A0A0A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4628 30.1141C64.6007 29.5259 64.4401 28.9853 64.104 28.9065C63.7679 28.8277 63.3837 29.2406 63.2458 29.8287C63.1079 30.4168 63.2685 30.9574 63.6046 31.0362C63.9407 31.115 64.3249 30.7022 64.4628 30.1141Z",
    fill: "#0A0A0A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8789 29.3433C61.4258 30.609 61.4258 32.0308 61.8946 33.2965C62.0039 33.609 62.1602 33.9058 62.3164 34.2027C62.4727 34.484 62.6446 34.7652 62.6914 35.0777C62.7852 35.6246 62.3633 36.0308 61.9258 36.2496C61.4727 36.484 61.8789 37.1558 62.3164 36.9215C62.8633 36.6402 63.3633 36.1402 63.4571 35.5152C63.5821 34.7496 63.1289 34.1246 62.8164 33.4683C62.2227 32.2496 62.1758 30.8121 62.6289 29.5465C62.7071 29.3433 62.5508 29.1246 62.3633 29.0621C62.1446 29.0152 61.9571 29.1402 61.8789 29.3433Z",
    fill: "#0A0A0A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1622 36.0942C57.0528 36.813 57.1935 37.5474 57.6466 38.1255C58.0685 38.6724 58.756 39.0161 59.4435 38.9849C59.6466 38.9692 59.8497 38.813 59.8341 38.5942C59.8185 38.3911 59.6622 38.188 59.4435 38.2036C59.381 38.2036 59.3028 38.2036 59.2403 38.2036C59.2091 38.2036 59.1622 38.188 59.2091 38.2036C59.1778 38.2036 59.131 38.188 59.0997 38.188C59.0372 38.1724 58.9747 38.1567 58.9278 38.1411C58.9122 38.1411 58.8341 38.1099 58.8653 38.1255C58.9122 38.1411 58.8185 38.1099 58.8028 38.0942C58.7403 38.063 58.6778 38.0317 58.6153 38.0005C58.5841 37.9849 58.5685 37.9692 58.5372 37.9536C58.4435 37.8911 58.5841 38.0005 58.4903 37.9224C58.4435 37.8755 58.3966 37.8442 58.3497 37.7974C58.3185 37.7661 58.3028 37.7505 58.2716 37.7192C58.2716 37.7192 58.2091 37.6411 58.2247 37.6724C58.256 37.7036 58.1778 37.6099 58.1935 37.6255C58.1778 37.5942 58.1622 37.5786 58.1466 37.5474C58.1153 37.4849 58.0841 37.4224 58.0372 37.3599C58.006 37.2974 58.0372 37.3599 58.0216 37.3286C58.006 37.2974 57.9903 37.2661 57.9903 37.2349C57.9591 37.1724 57.9435 37.0942 57.9278 37.0317C57.9122 36.9692 57.8966 36.8911 57.881 36.813C57.881 36.8599 57.881 36.8286 57.881 36.7974C57.881 36.7505 57.881 36.7192 57.8653 36.6724C57.8653 36.6099 57.8653 36.5474 57.8653 36.4692C57.8653 36.4224 57.8653 36.3911 57.8653 36.3442C57.8653 36.3286 57.881 36.2192 57.8653 36.2974C57.8966 36.0942 57.8185 35.8755 57.5997 35.813C57.4591 35.7817 57.1935 35.8755 57.1622 36.0942Z",
    fill: "#0A0A0A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2712 28.5769C56.2399 27.6082 57.7087 27.2644 59.0055 27.6863C59.4899 27.8425 59.693 27.0925 59.2087 26.9363C57.6618 26.4363 55.8649 26.8738 54.7087 28.03C54.3649 28.3894 54.9118 28.9363 55.2712 28.5769Z",
    fill: "#0A0A0A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0971 27.7827C64.2221 27.814 64.3471 27.8609 64.4721 27.9077C64.4877 27.9077 64.5033 27.9234 64.5189 27.9234C64.5658 27.939 64.5033 27.9234 64.4877 27.9077C64.5189 27.9234 64.5502 27.939 64.5815 27.9546C64.644 27.9859 64.7064 28.0171 64.7689 28.0484C64.8783 28.1109 64.9877 28.1734 65.0971 28.2515C65.1283 28.2671 65.1439 28.2827 65.1752 28.314C65.1908 28.3296 65.2065 28.3296 65.2065 28.3452C65.2221 28.3452 65.2689 28.3921 65.2221 28.3452C65.1752 28.314 65.2221 28.3452 65.2377 28.3452C65.2533 28.3609 65.2689 28.3609 65.2689 28.3765C65.3002 28.3921 65.3314 28.4234 65.3471 28.4546C65.5033 28.5952 65.7533 28.6109 65.8939 28.4546C66.0346 28.314 66.0658 28.0484 65.8939 27.9077C65.4408 27.5015 64.8939 27.2046 64.3002 27.0484C64.0971 27.0015 63.8627 27.1109 63.8158 27.314C63.7846 27.5015 63.8939 27.7202 64.0971 27.7827Z",
    fill: "#0A0A0A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1914 69.3291L16.7695 61.6416",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4258 78.313L32.2852 70.563",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0508 87.7661L71.7227 106.719",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4551 28.7964L93.8457 12.2026L114.143 24.3901L138.471 3.98389",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2237 29.4638C78.5846 27.9353 77.6382 26.4037 76.1097 26.0427C74.5812 25.6818 73.0496 26.6283 72.6886 28.1568C72.3277 29.6853 73.2742 31.2169 74.8027 31.5778C76.3312 31.9387 77.8628 30.9922 78.2237 29.4638Z",
    fill: "#FF5D0E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6439 12.6573C96.8955 11.107 95.8427 9.64626 94.2924 9.39466C92.7421 9.14305 91.2814 10.1959 91.0298 11.7462C90.7782 13.2965 91.831 14.7572 93.3813 15.0088C94.9316 15.2604 96.3923 14.2076 96.6439 12.6573Z",
    fill: "#FF5D0E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M114.143 27.2344C115.713 27.2344 116.986 25.9612 116.986 24.3906C116.986 22.8201 115.713 21.5469 114.143 21.5469C112.572 21.5469 111.299 22.8201 111.299 24.3906C111.299 25.9612 112.572 27.2344 114.143 27.2344Z",
    fill: "#FF5D0E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M141.283 4.42683C141.534 2.87653 140.481 1.4158 138.931 1.1642C137.381 0.912593 135.92 1.9654 135.668 3.5157C135.417 5.066 136.47 6.52672 138.02 6.77832C139.57 7.02993 141.031 5.97713 141.283 4.42683Z",
    fill: "#FF5D0E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M141.316 86.7344L139.863 104.922C139.785 105.922 138.957 106.688 137.957 106.688H129.707C128.707 106.688 127.879 105.922 127.801 104.922L126.348 86.7344H141.316Z",
    fill: "#0A0A0A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M133.816 88.3755C137.959 88.3755 141.316 87.6689 141.316 86.7974C141.316 85.9258 137.959 85.2192 133.816 85.2192C129.674 85.2192 126.316 85.9258 126.316 86.7974C126.316 87.6689 129.674 88.3755 133.816 88.3755Z",
    fill: "#9F99AA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M133.816 88.3755C137.959 88.3755 141.316 87.6689 141.316 86.7974C141.316 85.9258 137.959 85.2192 133.816 85.2192C129.674 85.2192 126.316 85.9258 126.316 86.7974C126.316 87.6689 129.674 88.3755 133.816 88.3755Z",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M133.816 86.7495C136.552 86.7495 138.77 86.2808 138.77 85.7026C138.77 85.1245 136.552 84.6558 133.816 84.6558C131.081 84.6558 128.863 85.1245 128.863 85.7026C128.863 86.2808 131.081 86.7495 133.816 86.7495Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M133.816 86.7495C136.552 86.7495 138.77 86.2808 138.77 85.7026C138.77 85.1245 136.552 84.6558 133.816 84.6558C131.081 84.6558 128.863 85.1245 128.863 85.7026C128.863 86.2808 131.081 86.7495 133.816 86.7495Z",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M138.77 85.7021V86.7334",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M128.863 85.7021V86.7334",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M127.395 100.233C129.301 100.452 131.473 100.577 133.801 100.577C136.129 100.577 138.316 100.452 140.207 100.233L140.754 93.4678C138.738 93.7334 136.348 93.8897 133.801 93.8897C131.254 93.8897 128.863 93.7334 126.848 93.4678L127.395 100.233Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M135.991 97.5687C136.275 96.3678 135.531 95.1644 134.33 94.8808C133.129 94.5972 131.926 95.3409 131.642 96.5418C131.359 97.7428 132.102 98.9462 133.303 99.2298C134.504 99.5133 135.708 98.7697 135.991 97.5687Z",
    fill: "#FF5D0E"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0.517578 106.751H152.486",
    stroke: "#0A0A0A",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2832 48.9063L93.2832 46.1563H135.346C137.096 46.1563 138.533 44.7344 138.533 42.9688V37.3906C138.533 35.6406 137.111 34.2031 135.346 34.2031H91.9082C90.1582 34.2031 88.7207 35.625 88.7207 37.3906V48.625C88.7363 48.8906 89.0488 49.0625 89.2832 48.9063Z",
    fill: "#9F99AA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M98.46 41.0803C98.7268 39.4363 97.6104 37.8873 95.9664 37.6205C94.3224 37.3537 92.7734 38.4701 92.5065 40.1141C92.2397 41.7581 93.3562 43.3071 95.0002 43.5739C96.6442 43.8407 98.1932 42.7243 98.46 41.0803Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M102.377 39.0776H131.346",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M102.377 42.2026H116.861",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPassword);
export default __webpack_public_path__ + "static/media/newPassword.124834e52ca3077569862f675bc293bf.svg";
export { ForwardRef as ReactComponent };